var Fraud;
(function (Fraud) {
    Fraud["PBPAYUnknownFraudCheck"] = "PBPAYUnknownFraudCheck";
    Fraud["PBPAYInvalidFraudCheckType"] = "PBPAYInvalidFraudCheckType";
    Fraud["PBPAYFraudThresholdHit"] = "PBPAYFraudThresholdHit";
    Fraud["PBPAYDuplicateFraudCheck"] = "PBPAYDuplicateFraudCheck";
    Fraud["PBPAYInvalidFraudCheck"] = "PBPAYInvalidFraudCheck";
})(Fraud || (Fraud = {}));
export default Fraud;
